var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { reaction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { useIntervalTimer } from 'ziphy-web-shared/basic/hooks';
import { globalLoaderHandlers, useLoaderSubscribe } from 'ziphy-web-shared/basic/utils';
import { $time } from 'ziphy-web-shared/basic/utils/time';
import { $calendar } from '@nedoShared/modules/calendar/Calendar.store';
import DashboardCalendar from '@nedoShared/modules/dashboard/dashboardSidebar/dashboardCalendar/DashboardCalendar';
import DashboardDayPicker from '@nedoShared/modules/dashboard/dashboardSidebar/DashboardDayPicker/DashboardDayPicker';
import styles from './DashboardSidebar.module.scss';
const DashboardSidebar = () => {
    const { t } = useTranslation();
    useIntervalTimer({
        callback: () => __awaiter(void 0, void 0, void 0, function* () { return yield $calendar.loadData(false); }),
        duration: 90000,
    });
    useLoaderSubscribe(globalLoaderHandlers.EVENT, (message) => __awaiter(void 0, void 0, void 0, function* () {
        if (message.isChatMessage)
            return;
        yield $calendar.loadData(false);
    }));
    useEffect(() => () => $calendar.clearFull(), []);
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield $calendar.init($time.timezone, $time.weekType);
            const day = $calendar.selectedDay;
            const begin = moment(day).startOf('month');
            const end = moment(day).endOf('month').endOf('week').add(1, 'second');
            $calendar.SET_LOAD_RANGE({
                _begin: begin,
                _end: end,
            });
            yield $calendar.loadData();
        }))();
        const disposers = [
            reaction(() => $calendar.isChangedRange, (newVal) => newVal && $calendar.loadData()),
        ];
        return () => disposers.forEach((fn) => fn());
    }, [$time.timezone, $time.weekType]);
    if (!$calendar.isInitialized) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs("div", Object.assign({ className: classNames(styles.wrapper) }, { children: [_jsx("div", Object.assign({ className: styles.calendar }, { children: _jsx(DashboardDayPicker, {}) })), _jsx("div", Object.assign({ className: styles.schedule }, { children: _jsx(DashboardCalendar, {}) }))] })));
};
export default observer(DashboardSidebar);
